module.exports = {"postcode":"Postleitzahl","enter_postcode":"Gib deine Postleitzahl ein","dont_remember":"Du kannst dich nicht erinnern?","select_province":"Wählen Sie die Provinz unten","incorrect_address":"Sorry, we couldn’t find any address matching","manual_address_flow":"Enter address manually","blocked_postal":"Die eingegebene Postleitzahl ist ungültig"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/postalCode.json
// module id = 498
// module chunks = 248 1675